<ui-page
  *ngIf="messageForm"
  [formGroup]="messageForm"
  [title]="'dataQuality.messageChecker.title' | translate"
  [hideBackBtn]="true"
  [noIndents]="true"
>
  <ng-container toolbar>
    <div class="right-align tw-flex tw-gap-x-8">
      <ui-action-button
        [action]="buttonAction.Check"
        [disabled]="!messageForm.get('message')?.value?.length"
        (buttonClick)="checkMessage()"
      ></ui-action-button>
      <ui-action-button [action]="buttonAction.Send" [disabled]="true" (buttonClick)="sendMessage()"></ui-action-button>
    </div>
  </ng-container>
  <ng-container body>
    <mat-form-field>
      <mat-label>
        {{ 'dataQuality.messageChecker.placeholder' | translate }}
      </mat-label>
      <textarea
        class="message__input scroll-decor"
        [ngClass]="{ 'validation-error': messageForm.invalid }"
        matInput
        formControlName="message"
      ></textarea>
      <mat-error>
        <ui-field-error-messages [control]="messageForm.get('message')"></ui-field-error-messages>
      </mat-error>
    </mat-form-field>
    <div
      *ngIf="errors$ | async as errors"
      class="message__errors tw-flex tw-flex-col"
      [ngClass]="{ 'no-errors': !errors.length }"
    >
      <div *ngIf="errors.length" class="tw-py-5">
        <div class="tw-grid tw-grid-cols-4 tw-border-solid tw-border-0 tw-border-b tw-border-dark-grey-400">
          <div class="tw-grid tw-col-span-1 tw-py-2 tw-px-2">
            <span class="tw-font-strong tw-text-dark-grey-400">
              {{ 'dataQuality.table.rawMessageErrors.segment' | translate }}
            </span>
          </div>
          <div class="tw-grid tw-col-span-3 tw-py-2 tw-px-2">
            <span class="tw-font-strong tw-text-dark-grey-400">
              {{ 'dataQuality.table.rawMessageErrors.errors' | translate }}
            </span>
          </div>
        </div>
        <div
          *ngFor="let message of errors; let lastRow = last"
          class="tw-grid tw-grid-cols-4 tw-border-solid tw-border-0 tw-border-dark-grey-400"
          [class.tw-border-b]="!lastRow"
        >
          <div class="tw-grid tw-col-span-1 tw-py-2 tw-px-2 tw-break-all">
            {{ message.segment }}
          </div>
          <div class="tw-grid tw-col-span-3 tw-py-2 tw-px-2">
            <span *ngFor="let error of message.errors; let isLast = last" class="tw-block" [class.tw-mb-4]="!isLast">
              {{ error }}
            </span>
          </div>
        </div>
      </div>
      <div *ngIf="!errors.length">
        {{ 'dataQuality.messageChecker.noErrorMessages' | translate }}
      </div>
    </div>
  </ng-container>
</ui-page>
